import { useContext, React, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import InputComponent from "../../../../components/InputComponent/InputComponent";
import Loader from "../../../../components/Loader/Loader";
import TextArea from "../../../../components/TextAreaBorderComponent/TextArea";
import ContentData from "../../../../constants/contentFile.json";
import NextIcon from "../../../../assets/images/next-icon.svg";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import { RoleEditContext } from "../EditRoleView";
import "./editRoles.css";
import ToggleArrow from "../../../../assets/images/Toggle-arrow.svg";

const EditRoles = () => {
  const {
    num,
    name,
    handleRoleName,
    validatedName,
    rolesList,
    handleDescription,
    editRoleformValidation,
    newPermissionCategory,
    spinnerStatus,
    userPermissionList,
    successAlertMessage,
    successAlertShow,
    errorAlertShow,
    errorAlertMessage,
    setErrorAlertShow,
    statusValue,
    roleToLogin,
    buttonText,
    dataUserPermissionList,
    description,
    validateDescription,
    featuresData,
    nameValidation,
    roleDetails,
  } = useContext(RoleEditContext);

  const navigate = useNavigate();

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={rolesList}>
          {ContentData.rolePermissions.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="breadCrumsPointing" onClick={() => navigate(-1)}>
          {ContentData.rolePermissions.roleDetail}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.rolePermissions.editRole}
        </span>
      </div>
      {spinnerStatus && <Loader />}
      <Container className="editRolesPage">
        <button type="button" onClick={roleDetails} class="navbar-btn">
          <img src={ToggleArrow} alt="toggle-arrow" />
        </button>
        <div className="pageTittles">
          {ContentData.rolePermissions.editRole}
        </div>
        <form onSubmit={editRoleformValidation}>
          <div className="basicContainer">
            <div className="viewAdminSection addAdminSection">
              <div>
                <Row>
                  <Col xl="3" lg="6" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.rolePermissions.roleName} *</h4>
                        <InputComponent
                          placeholder={ContentData.rolePermissions.typeRole}
                          value={name}
                          onChange={handleRoleName}
                          handleBlur={nameValidation}
                        />
                        <p className="mb-0 error-msg">
                          {validatedName ? validatedName : ""}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col xl="12" lg="12" sm="12">
                    <div className="adminDetailSection">
                      <div className="adminDetailSectionTop roleSubPage">
                        <h4>{ContentData.rolePermissions.description} *</h4>
                        <TextArea
                          value={description}
                          onChange={handleDescription}
                          placeholder={
                            ContentData.rolePermissions.typeDescription
                          }
                        />
                        <p className="mb-0 error-msg">
                          {validateDescription ? validateDescription : ""}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>

          <div className="basicContainerRoleData">
            <div className="subHead">
              {ContentData.rolePermissions.permissionHead}
            </div>

            {featuresData?.map((feature, index) => {
              const userPermission = userPermissionList.find(
                (permission) => permission.feature._id === feature._id
              );

              return (
                <div key={index} className="flexPermission">
                  <div className="roleNameChoose">
                    <span>
                      {feature.name ? feature.name : "Unknown Feature"}
                    </span>
                  </div>
                  <div className="rolePermissions">
                    <div className="checkBoxDataPerm">
                      <CheckBox
                        label="View"
                        check={userPermission?.view || false}
                        id={feature.name + "_view"}
                        handleCheck={() => {
                          newPermissionCategory(
                            feature._id,
                            "view",
                            userPermission?.view || false
                          );
                        }}
                      />
                    </div>
                    <div className="checkBoxDataPerm">
                      <CheckBox
                        label="Add"
                        check={userPermission?.add || false}
                        id={feature.name + "_add"}
                        handleCheck={() => {
                          newPermissionCategory(
                            feature._id,
                            "add",
                            userPermission?.add || false
                          );
                        }}
                      />
                    </div>
                    <div className="checkBoxDataPerm">
                      <CheckBox
                        label="Edit"
                        check={userPermission?.edit || false}
                        id={feature.name + "_edit"}
                        handleCheck={() => {
                          newPermissionCategory(
                            feature._id,
                            "edit",
                            userPermission?.edit || false
                          );
                        }}
                      />
                    </div>
                    <div className="checkBoxDataPerm">
                      <CheckBox
                        label="Delete"
                        check={userPermission?.delete || false}
                        id={feature.name + "_delete"}
                        handleCheck={() => {
                          newPermissionCategory(
                            feature._id,
                            "delete",
                            userPermission?.delete || false
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="bottomButtons">
            <BorderButton
              value={ContentData.authPage.cancelText}
              onClick={roleDetails}
            />
            <ThemeButton
              value={ContentData.authPage.submitText}
              id="submitAddEditBtn"
              type="submit"
            />
          </div>
        </form>
      </Container>
      <PopupAlertError
        show={errorAlertShow}
        alertMessage={errorAlertMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorAlertShow(false)}
        handleSubmit={() => {
          if (statusValue === 401) {
            roleToLogin();
            setErrorAlertShow(false);
          } else {
            setErrorAlertShow(false);
            document.getElementById("submitAddEditBtn").click();
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />
      <SuccessPopupAlert
        show={successAlertShow}
        alertMessage={successAlertMessage}
        handleSubmit={roleDetails}
      />
    </div>
  );
};

export default EditRoles;
